import request from 'superagent';
import Model from '../model';
import * as actions from './actions'
import * as PaymentSelector from './selector'
import {NetworkSelector} from '/app/src/model/selectors'


class Payment extends Model {
    constructor() {
        super()
        this.selector = PaymentSelector
    }

    paymentSpecsRead() {
        const selector = (state) => ({
            network: NetworkSelector.get(state, 'payment info read')
        })

        const dispatcher = (dispatch) => {
            const url = this.url()
            const token = this.token()
            dispatch(actions.paymentPlansReadRequested())
            request
            .post(`${url}/v2/api/payment/plans`)
            .accept('application/json')
            .send({})
            .set('Authorization', 'Bearer ' + token)
            .end((err, res) => {
                switch(res.statusCode) {
                    case 200:
                        dispatch(actions.paymentPlansReadSucceeded(res.body))
                        break;
                    default:
                        return;
                }
            });
        }
        return { dispatcher: dispatcher, selector: selector}
    }
}
export default new Payment();



// WEBPACK FOOTER //
// ./src/model/Payment/model.js